import { useEffect } from 'react';

/**
 * Hook che cambia il titolo della pagina in modo discreto per attirare l'attenzione
 * quando la pagina è in background (non visibile).
 *
 * Ogni 8 secondi alterna tra:
 * - "📄 CV disponibile"
 * - "Walter Rodeghiero — Sviluppatore C#/.NET"
 *
 * Ritorna al titolo originale quando la pagina ritorna in focus.
 */
export function useAttentionTitle(originalTitle: string = 'Walter Rodeghiero — Sviluppatore C#/.NET') {
  const messages = [
    '📄 CV disponibile',
    'Walter Rodeghiero — Sviluppatore C#/.NET'
  ];

  useEffect(() => {
    let isPageVisible = true;
    let intervalId: NodeJS.Timeout | null = null;
    let messageIndex = 0;

    // Gestisci il cambio di focus della pagina
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // La pagina è andata in background
        isPageVisible = false;
        messageIndex = 0;

        // Cambia il titolo ogni 8 secondi (meno invasivo)
        intervalId = setInterval(() => {
          document.title = messages[messageIndex];
          messageIndex = (messageIndex + 1) % messages.length;
        }, 8000);
      } else {
        // La pagina è ritornata in primo piano
        isPageVisible = true;

        // Ferma il cambio del titolo
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }

        // Ripristina il titolo originale
        document.title = originalTitle;
      }
    };

    // Aggiungi il listener per il cambio di visibilità
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [originalTitle, messages]);
}
